import { AttributesMixin, define, type, Model } from "@type-r/models";
import { CompanyItem } from "./company";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";
import { Mapping } from "./mapping";
import { Metadata } from "./importTemplateMetadata";
import { StaticField } from "./staticField";
import { AssetTypeItem } from "./assetTypes";
import { AssetFilterCriteria, WorkSheet } from "./assetFilterCriteria";
import { ComputedField } from "./computedField";
export interface ImportTemplateDetailsDto extends AttributesMixin<typeof ImportTemplateDetailsDto> { }

@define
export class ImportTemplateDetailsDto extends Model {
  static endpoint = restfulIO('api/v1/ingest/import-templates');

  static attributes = {
    id: String,
    name: String,
    originalFileName: String,
    assetTypeId: Number,
    assetTypes: [AssetTypeItem],
    url: String,
    file: String,
    metadata: Metadata,
    isDefault: Boolean,
    isActive: Boolean,
    isStandard: Boolean,
    companies: [CompanyItem],
    mappings: [Mapping],
    staticFields: [StaticField],
    computedFields: [ComputedField],
    omitUnmappedFields: Boolean,
    delimiter: String,
    assetFilterCriteria: AssetFilterCriteria,
    workSheet: WorkSheet
  };

  async get(id: string): Promise<ImportTemplateDetailsDto> {
    const url = `api/v1/ingest/import-templates/${id}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'X-Platform-Code': getPlatformCode()
      }),
    });

    if (response.status < 200 || response.status >= 300) {
      // TODO in case of not found maybe we have a need in more specific error message
      // TODO like a "Import Template was not found"
      let error = response.statusText || `HTTP Error ${response.status}`;
      await response.json()
        .then(e => error = Object.keys(e.errors).map(k => e.errors[k].join(' ')).join(' '))
        .catch(e => console.error('Cannot parse response data'));
      throw new Error(error);
    }

    const json = await response.json();
    this.set(json);
    return this;
  }
}